import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type QuarantineBase from "@/pages/Quarantine.Base.vue";

export default defineMosaicComponent<typeof QuarantineBase>("pages/Quarantine");
